import { InvertMaskModeType } from "products/components/invert-mask-marker";
import {SensitivityType, Size} from "app/types/model-types";
import { ID, intboolean } from "app/types/app-types"

export type PreviewImage = {
    id: ID
    imageId?: ID
    imageHash?: string
    userSetObjects?: string
    imageUrlHash?: string
    imageWidth?: number
    imageHeight?: number
    maskHash?: string
    maskMode?: InvertMaskModeType
    name: string
    itemId: string
    imageUrl: string
    shopUrl: string
    previewUrl: string
    templateActive: number
    templateActiveFrom: string|null
    templateActiveTo: string|null
    templateId: number
    templateName: string
    templateSize: Size
    isSourceByTypeExists: boolean
    renderedType: number
    renderedSensitivity: SensitivityType
}

export type PreviewsData = {
    page: number
    last_page: number
    items: PreviewImage[]
    from?: 'project' | string
}

export type PreviewsSettings = {
    type: "size" | "template"
    id: ID
    page: number
    rawImages: intboolean
    allowCache: intboolean
    active: intboolean
    itemsPerPage: number
}

export const DEFAULT_PRODUCTS_PER_PAGE = 9

export const defaultPreviewsSettings: PreviewsSettings = {
    type: "size",
    id: "ALL",
    page: 1,
    rawImages: 0,
    allowCache: 1,
    active: 1,
    itemsPerPage: DEFAULT_PRODUCTS_PER_PAGE,
}

export type PreviewsForm = {
    view: PreviewsSettings
    randomNumber: number
}